import ImportRepository from "@domain/repositories/ImportRepository";
import UseCase from "@domain/UseCase";
import { DbClient } from "@domain/models/DbClient";
import { ImportJob } from "@domain/models/ImportJob";

type Input = {
  type: "auxBrasil" | "indeferidosDb" | "deferidos";
  dbClients: DbClient[];
};

type Output = Promise<ImportJob>;

export class ImportDbClientsUseCase implements UseCase<Input, Output> {
  constructor(private readonly httpClientRepository: ImportRepository) {}

  execute({ type, dbClients }: Input) {
    return this.httpClientRepository.importDbClients(type, dbClients);
  }
}
